import { FilterStore } from 'ynf-core-engine/stores'
import { observable, extendObservable, action } from 'mobx'

export default class ReferFilterStore extends FilterStore {
  [x: string]: any
  constructor (...props: any) {
    super(...props)

    extendObservable(this, {
      hasFilter: false, // 是否能切换
      filterVisible: false, // 查询区控制
      searchVisible: true, // 参照本身的搜索控制
    })
  }

  switchFilter = () => {
    this.filterVisible = !this.filterVisible
    this.searchVisible = !this.searchVisible
  }

}